import type { Instructor } from '../types/content';
import { IMAGES } from './images';

export const instructors: Instructor[] = [
  {
    id: 'maggie',
    name: 'Maggie Mordaunt',
    nickname: 'CCW Maggie',
    role: 'Founder & Lead Instructor',
    bio: 'NRA instructor since 2009 and NRA Training Counselor since 2014. Wife, mom and a defense-only instructor who has personally trained more than 14,000 students.',
    credentials: ['NRA Training Counselor', 'Sheriff-approved CCW instructor', '14,000+ students trained'],
    image: IMAGES.maggie,
  },
  {
    id: 'ken',
    name: 'Ken Ortega',
    role: 'Owner & Lead Instructor',
    bio: 'Co-owner and lead instructor known for his calm coaching and ability to diagnose and correct a shooter’s fundamentals in minutes.',
    credentials: ['Lead defensive handgun instructor', 'Carbine & low light programs'],
    image: IMAGES.ken,
  },
  {
    id: 'team',
    name: 'Our Vetted Instructor Team',
    role: 'Certified, coached and held to our standard',
    bio: 'Every HPP instructor is certified, mentored in our defense-only method and evaluated before they teach a single class.',
    credentials: ['NRA & USCCA certified', 'Sheriff-approved CCW instructors'],
    image: IMAGES.students,
  },
];
